import { InteractionSummaryResponseModel } from '@capturi/api-insights'
import { Segment } from '@capturi/filters'
import { SectionHeading } from '@capturi/ui-components'
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import { Trans, t } from '@lingui/macro'
import React from 'react'

import DataBasisOverview from '../../../shared/components/DataBasisOverview'
import {
  TeamSegmentsData,
  UserSegmentsData,
} from '../../data/useSpeakerDistributionDataStats'
import { Event, logEvent } from '../../events'
import { TeamBreakdown } from './TeamBreakdown'
import { TimeSeries } from './TimeSeries'
import { UserBreakdown } from './UserBreakdown'

export type SpeakerDistributionProps = {
  summaries: Segment<InteractionSummaryResponseModel>[]
  onPlaySnippets: (
    row: UserSegmentsData | TeamSegmentsData,
    segmentIndex: number,
  ) => void
}

export const SpeakerDistribution: React.FC<SpeakerDistributionProps> = ({
  summaries,
  onPlaySnippets,
}) => {
  return (
    <Box>
      <SectionHeading>
        <Trans>Talk ratio</Trans>
      </SectionHeading>
      <DataBasisOverview segments={summaries} mb={4} />
      <TimeSeries
        onResolutionChange={(resolution) => {
          logEvent(Event.TimeSeries_ChangeResolution, 'speaker-distribution', {
            resolution,
          })
        }}
      />

      <Tabs isLazy mt={4}>
        <TabList>
          <Tab key="employees">{t`Employees`}</Tab>
          <Tab key="teams">{t`Teams`}</Tab>
        </TabList>
        <TabPanels>
          <TabPanel key="employees" px={0}>
            <UserBreakdown
              summaries={summaries}
              onPlaySnippets={onPlaySnippets}
            />
          </TabPanel>
          <TabPanel key="teams" px={0}>
            <TeamBreakdown
              summaries={summaries}
              onPlaySnippets={onPlaySnippets}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
}
